import type { Provider } from './types';

import gmailIcon from 'assets/images/logos/gmail.svg';
import googleIcon from 'assets/images/logos/google.svg';

export const gmail: Provider = {
  label: 'Gmail',
  icon: gmailIcon,
  nylasName: 'google',
  scopes: ['https://www.googleapis.com/auth/gmail.readonly'],
  ssoLabel: 'Google',
  ssoIcon: googleIcon,
};

export const outlook: Provider = {
  label: 'Outlook',
  icon: '',
  nylasName: 'microsoft',
  scopes: ['https://graph.microsoft.com/Mail.Read'],
  ssoLabel: 'Microsoft',
  ssoIcon: '',
};
